<template>
    <div class="pandora-border">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'PandoraBorder'
}
</script>

<style>
.pandora-border {
    max-width: 1200px;
    margin: auto;
    min-height: 76vh;
    position: relative;
    padding: 1rem;

    background-color: rgb(255, 255, 255);
}

@media (min-width: 1215px) {
    .pandora-border {
        z-index: 1;
        padding: 1rem 2.5rem;
        margin-top: -2.5rem;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 10px;
    }
}

@media (min-width: 1078px) {
    .border-w .pandora-border {
        width: max-content;
        z-index: 1;
        margin-top: -3rem !important;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 10px;
    }
}
</style>